import { CreditHold } from 'src/app/shared/components/CreditHold/index.tsx';
import { CREDIT_HOLD_OUTSTANDING_INVOICES_PRESSED } from 'src/app/shared/dataAnalytics/schema/constants';
import { useAnalyticsTracking } from 'src/app/v2/hooks/useAnalyticsTracking';
import { useHeaderFooterContext } from 'src/app/v2/hooks/useHeaderFooterContext';

interface Props {
  renderAlert?: boolean;
}

export const CreditHoldSection = ({ renderAlert = true }: Props) => {
  const context = useHeaderFooterContext();
  const { trackingAdapter } = useAnalyticsTracking();

  const onHandleOutstandingClick = () => {
    const eventData = {
      eventName: CREDIT_HOLD_OUTSTANDING_INVOICES_PRESSED,
      objectInteraction: 'credit-hold-outstanding-invoices',
    };
    trackingAdapter.sendLinkEvent(eventData);
  };

  return (
    <CreditHold
      renderAlert={renderAlert}
      userCanPayInvoices={Boolean(
        context?.advertiser?.permissionOptions.canPayInvoices,
      )}
      onHandleOutstandingClick={onHandleOutstandingClick}
    />
  );
};
